import React from 'react'
import { MenuTemplate } from '../../templates/MenuTemplate'

/**
 * Componente pagina di errore
 * @component
 */
export const Error: React.FC = () => {
  //TODO
  return (
    <MenuTemplate>
      <div data-cy={'error-message'}>ERROR</div>
    </MenuTemplate>
  )
}
